import { render, staticRenderFns } from "./PrefixFormDialog.vue?vue&type=template&id=3ce2f154"
import script from "./PrefixFormDialog.vue?vue&type=script&lang=js"
export * from "./PrefixFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports